import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi'; //eslint-disable-line monorepo/no-internal-import

import { change } from 'redux-form';
import { getLocale, getHeadConfig } from '@ynap/config-state';

export const selectMarketingConsentIfNeeded = (formName, field) => {
    return (dispatch, getState) => {
        const state = getState();
        const { country } = getLocale(state);
        const { automaticConsentCountryList } = getHeadConfig(state);
        if (automaticConsentCountryList) {
            const geoCountry = getCookie('geoIP');
            if (geoCountry) {
                if (automaticConsentCountryList.includes(geoCountry) && automaticConsentCountryList.includes(country)) {
                    return dispatch(change(formName, field, 'true'));
                }
            }
        }
    };
};
